import React from "react";
// import { getDataArray } from "../../helpers/getGridData";
// import ApiClient from "utils/ApiClient";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Table from "../../views/table/Table";
import TableStore from "app/list/views/table/TableStore";
import ApiClient from "utils/ApiClient";

export default function SubsheetPopup({
  isOpen,
  onSave,
  values,
  store,
  setFieldValue,
}) {
  const {
    column_name: columnName,
    list_id: parentListId,
    options: { sub_list_id: listId },
    column_id: columnId,
  } = values;
  values.list_columns = values.list_columns ?? [];
  const listColumns = values.list_columns;

  const [columns, setColumns] = React.useState(
    listColumns.map((col) => {
      if (!col.dataIndex) {
        col.dataIndex = "column_" + col["id"];
      }
      return col;
    })
  );

  //Using reference to edit column config.
  const handleColumnConfigChange = async (columnConfig) => {
    store.containerStore.handleSubsheetColumnConfigChange(
      columnConfig,
      columnId,
      listColumns
    );
    setColumns([...listColumns]);
    if (!columnId) {
      const column = await store.saveColumn(values, false);
      setFieldValue("column_id", column.id);
    }
  };

  const handleColumnDelete = async (id) => {
    await store.containerStore.handleSubsheetColumnDelete(
      id,
      columnId,
      listColumns
    );
    setColumns([...listColumns]);
    return true;
  };

  const tableProps = {
    isSubsheet: true,
    columnId: columnId,
    rowId: "",
    parentListId: parentListId,
    listId: listId,
    columns: [...columns],
    listName: columnName,
    onColumnConfigChange: handleColumnConfigChange,
    parentRow: {},
    isEventsColumnHidden: true, //set to true for delete field to be disbaled in edit mode in subsheet
    handleColumnDelete,
    isAddRowDisabled: true,
    isGroupByHidden: true,
    isSortingHidden: true,
    isHideColumnHidden: true,
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={isOpen}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent
          className="ag-theme-material-custom"
          style={{ height: 500 }}
        >
          <Table
            {...tableProps}
            store={new TableStore(tableProps, store.containerStore)}
          />
        </DialogContent>
        <DialogActions>
          {/* <TextField variant="outlined" label="New Entry Button Name" /> */}
          <Button onClick={onSave} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
